import {
  formatDate,
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_VACANCIES } from './constants';

const initialState = {
  results: null,
  isFetching: false,
  fetchingErrors: null
};

function formatNewsDate(post) {
  if (!post) {
    return post;
  }

  return Object.assign({}, post, {
    dateDisplay: formatDate(post.datePublished)
  });
}

export default createReducer(initialState, {
  [GET_VACANCIES]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        const { response } = action.request;

        return Object.assign(state, {
          results: response.results.map(formatNewsDate),
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/Vacancies/reducer.js